import $ from 'jquery';

export default function () {
    const langBlock = $('.language.language_select');

    $(langBlock).on('click', function (e) {
        const clicked = this;
        if ($(e.target).hasClass('language__curent')) {
            e.preventDefault();
        }
        $(clicked).toggleClass('language_opened');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).hasClass('language__curent')) {
            $('.language.language_select.language_opened').removeClass('language_opened');
        }
    });
}